import React, { ReactElement } from 'react';
import Button from '../button/button.component';
import TextBlock from '../text-block/text-block.component';
import FlexContainer from '../flex-container/flex-container.component';
import IconBlockSuccess from '../icon-block-success/icon-block-success.component';
import IconBlockError from '../icon-block-error/icon-block-error.component';
import FormatService from '../../services/format-service';
import useStylesActionBlock from './action-block.styles';

const ActionBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isInline,
    isColumnView,
    isSuccessful,
    withNoButton,
    withMultilineLabels,
    className,
    labelSuccess,
    labelError,
    labelButton,
    onButtonClick,
  } = props;

  const { classes } = useStylesActionBlock();

  const inlineClassName: string | undefined = isInline ? classes.actionBlockInline : undefined;
  const containerColumnClassName: string | undefined = isColumnView ? classes.actionBlockContainerColumn : undefined;
  const textBlockLabelMultilineClassName: string | undefined = withMultilineLabels
    ? classes.textBlockLabelMultiline : undefined;

  return (
    <FlexContainer className={FormatService.formatClassNames(inlineClassName, className)}>
      {
        isSuccessful ? (
          <FlexContainer>
            <IconBlockSuccess />
            <TextBlock
              className={FormatService.formatClassNames(classes.textBlockLabel, textBlockLabelMultilineClassName)}
            >
              {labelSuccess}
            </TextBlock>
          </FlexContainer>
        ) : (
          <FlexContainer isColumn={isColumnView} className={containerColumnClassName}>
            <FlexContainer>
              <IconBlockError />
              <TextBlock
                className={FormatService.formatClassNames(classes.textBlockLabel, textBlockLabelMultilineClassName)}
              >
                {labelError}
              </TextBlock>
            </FlexContainer>
            {
              !withNoButton && (
                <FlexContainer>
                  <Button
                    isText
                    isActive
                    isDefault
                    className={classes.button}
                    onClick={onButtonClick}
                  >
                    {labelButton}
                  </Button>
                </FlexContainer>
              )
            }
          </FlexContainer>
        )
      }
    </FlexContainer>
  );
});

export default ActionBlock;
